<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
  name: "TheFooter"
})
</script>

<template>
<footer class="md:fixed px-4 md:px-16 py-4 bottom-0 left-0 w-full block md:flex justify-between items-center">
  <div class="mb-2 md:mb-0">
    &copy; 2025 Online Markets
  </div>
  <div>
    <a href="https://t.me/onlinemarkets_bot" target="_blank">
      <div class="flex justify-center">
        <span class="mr-2">Ապրանքների գները՝ Telegram հավելվածում</span>
        <img src="@/assets/telegram.svg" class="h-5 inline-block" alt="Telegram logo" />
      </div>
    </a>
  </div>

</footer>
</template>

<style scoped>
footer {
  background-color: #f2f2f2;
  color: #1f1f1f;
  text-align: center;
  font-size: 0.8rem;
  font-weight: 500;
}
</style>